module.exports = __webpack_public_path__ + "1c61e3b1631ddfc189ca1dbc415fc2b1.png";